import Link from 'next/link';
import cn from 'classnames';
import { ContentfulClick } from '@libs/analytics';
import { LayoutContainer, Picture } from '@petsmart-ui/sparky';
import { HeaderCtaTracker } from '../../../utils/HeaderCtaTracker';
import { propsImageItems } from '../../../utils/propsImagesItems';
import type { CampaignCarsUpProps } from '../types';
import { Text } from '../../Text';
import './info.scss';

export function CampaignCardsInfo({
    header,
    body,
    backgroundFill,
    textLink,
    textLinkColor,
    cardsTextColor,
    cards,
    textColor,
}: CampaignCarsUpProps) {
    return (
        <LayoutContainer className="campaign-cards-info">
            <div className="campaign-cards-info__content" style={{ background: backgroundFill }}>
                <div className="campaign-cards-info__header">
                    <Text color={textColor} as="h2">
                        {header}
                    </Text>
                    <Text align="center" color={textColor}>
                        {body}
                    </Text>

                    {textLink && (
                        <HeaderCtaTracker
                            textLink={textLink}
                            linkTextColor={textLinkColor}
                            header={header ?? ''}
                            promoVariant="campaign cards up - info"
                            promoType="campaign-cards-info__card"
                        />
                    )}
                </div>
                <div className="campaign-cards-info__cards">
                    {cards?.map((card, index) => {
                        const imageItems = propsImageItems(card.image);
                        const linkUrl = card?.link?.webUrl || textLink?.link?.webUrl || '';
                        const Component = linkUrl ? Link : 'div';

                        return (
                            <ContentfulClick
                                component={Component}
                                key={card.sysId}
                                className="campaign-cards-info__card"
                                style={{ background: card.backgroundFill }}
                                href={linkUrl}
                                eventData={{
                                    position: index + 1,
                                    linkText: cn(card.header, card.body),
                                    linkUrl,
                                    promoTitle: header ?? '',
                                    promoVariant: 'campaign cards up - info',
                                    promoDesc: card.internalTitle,
                                    promoType: 'campaign-cards-info__card',
                                }}
                                prefetch={false} // https://petsmart.atlassian.net/browse/HCP-594
                            >
                                <Picture
                                    imgSrc={imageItems[0]?.srcSet}
                                    imgAlt={card.image.webAltText}
                                    items={imageItems}
                                />

                                <div>
                                    <Text color={cardsTextColor} className="campaign-cards-info__card-title">
                                        {card.header}
                                    </Text>
                                    <Text color={cardsTextColor}>{card.body}</Text>
                                </div>
                            </ContentfulClick>
                        );
                    })}
                </div>
            </div>
        </LayoutContainer>
    );
}
